export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "no_document": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun fichier joint."])},
        "open_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir le fichier"])},
        "preview_unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aperçu indisponible pour ce format."])}
      },
      "en": {
        "no_document": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No file attached."])},
        "open_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open file"])},
        "preview_unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preview unavailable for this format."])}
      }
    }
  })
}
